/**
 * 常见硬编码按钮文案映射（按语言分组）
 *
 * 背景：全站大量业务页面把按钮文案写死在模板/属性里（如 <j-modal cancelText="关闭">），
 * 逐页改造周期长。JModal 等公共组件出口处会调用 translateButtonText 按此映射翻译，
 * 未收录的文案回退显示原文。
 *
 * 维护说明：业务页面后续改造为 $t() 后可逐步移除对应条目；新增语言时平级增加分组。
 */
export default {
  'en-US': {
    '关 闭': 'Close',
    '关闭': 'Close',
    '取 消': 'Cancel',
    '取消': 'Cancel',
    '确 定': 'OK',
    '确定': 'OK',
    '保 存': 'Save',
    '保存': 'Save',
    '提 交': 'Submit',
    '提交': 'Submit',
    '重 置': 'Reset',
    '重置': 'Reset',
    '查 询': 'Search',
    '查询': 'Search',
    '搜 索': 'Search',
    '搜索': 'Search',
    '编 辑': 'Edit',
    '编辑': 'Edit',
    '删 除': 'Delete',
    '删除': 'Delete',
    '新 增': 'Add',
    '新增': 'Add',
    '详 情': 'Details',
    '详情': 'Details',
    '导 入': 'Import',
    '导入': 'Import',
    '导 出': 'Export',
    '导出': 'Export',
    '打 印': 'Print',
    '打印': 'Print'
  }
}
